import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Language } from './components/Language';
import Password from './components/Password';
import PushNotification from './components/PushNotification';
import { useProfileInfoContext } from 'contexts/profileInfo';
import { StyledTitle } from 'components/StyledTitle';

const { Title: AntdTitle, Text } = Typography;

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 4fr;
  padding: 40px 0;
  row-gap: 16px;
`;

const TitleWrapper = styled.div`
  grid-column: 1/3;
`;

const SubtitleWrapper = styled.div`
  padding-left: 24px;
  background-color: var(--neutral-3);
  display: flex;
  align-items: center;
`;

const SettingsPage = () => {
  const { t } = useTranslation();
  const { state } = useProfileInfoContext();
  return (
    <Wrapper>
      <TitleWrapper>
        <AntdTitle level={4}>{t('settings.managePushNotification')}</AntdTitle>
      </TitleWrapper>
      <SubtitleWrapper>
        <Text>{t('settings.marketingUpdates')}</Text>
      </SubtitleWrapper>
      <PushNotification />
      <TitleWrapper>
        <AntdTitle level={4}>{t('settings.changePassword')}</AntdTitle>
      </TitleWrapper>
      <SubtitleWrapper>
        <Text>{t('settings.changePassword')}</Text>
      </SubtitleWrapper>
      <Password />
      <TitleWrapper>
        <StyledTitle level={4} margin="32px 0 10px 0">
          {t('profile.languageSetting')}
        </StyledTitle>
      </TitleWrapper>
      <Language data={state} />
    </Wrapper>
  );
};

export default SettingsPage;
